import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AuthService } from '../__auth/auth.service';
import { environment } from 'src/environments/environment';
import { SecurityLayerService } from '../__auth/security-layer.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  
  constructor(private router: Router,private securityLayer: SecurityLayerService, private authService: AuthService) {}

  canActivateOld(): Observable<boolean | UrlTree> {
    return this.authService.checkSession().pipe(
      map(response => {
        if (response.loggedIn) {
          return true;  // Allow access
        } else {
          this.router.navigate(['login']);
        }
      }),
      catchError(() => {
        // If checkSession fails (e.g., server down), redirect to login
        return of(this.router.parseUrl('/login'));
      })
    );
  }

  canActivate(): Observable<boolean | UrlTree> {
  if (environment.skipAuthGuard) {
    return of(true); // bypass auth while debugging
  }

  return this.authService.checkSession().pipe(
    map(res => res?.loggedIn ? true : this.router.createUrlTree(['/login'])),
    catchError(() => of(this.router.createUrlTree(['/login'])))
  );
}

  tryLogin(){
    this.securityLayer.tryLogin(this.securityLayer.getSecurityLayerObj());
  }

}